import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_STORE,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'
import { normalizeCheckRegisterAction } from '@/common/normalize/normalize-check-register-action'

export const getCouponCheckRegisterAction = async ({ couponNumber = '' }) => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_STORE}/v1/coupons/${couponNumber}/check-register-action`,
      method: HTTP_METHOD_GET,
    })

    if (!response) return { data: undefined }

    response.data = normalizeCheckRegisterAction(response?.data)

    return response
  } catch (error) {
    return {
      error: error.response,
    }
  }
}
